import { Button, Stack, Typography } from "@mui/material";
import { Syringe } from "lucide-react";
import React from "react";
import { useApp } from "../contexts/AppContext";

interface EmptyTableProps {
  label?: string;
  onClick: () => void;
}

const EmptyTable: React.FC<EmptyTableProps> = ({ label, onClick }) => {
  const { translate } = useApp();
  const translations = translate("general");

  return (
    <Stack
      mt={24}
      spacing={1}
      textAlign={"center"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Syringe size={40} />
      <Typography fontSize={18} variant="title">
        {label || translations.emptyState.title}
      </Typography>
      <Typography
        sx={{ color: "#000000" }}
        fontSize={14}
        variant="body2"
        color="textSecondary"
      >
        {translations.emptyState.subtitle}
      </Typography>
      <Button key={"create"} color="blackButton" onClick={() => onClick()}>
        {translations.history.buttons.addNewCycle}
      </Button>
    </Stack>
  );
};

export default EmptyTable;
